import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Card, CardBody, DropdownToggle, DropdownMenu, Dropdown, DropdownItem } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import defaultValues from "../../constants/defaultValues";
import { addBookingItem } from "../../redux/booking/actions";

const MolainnKeylessAccessContainer = ({ booking, hotelConfig, match, allBookingItems, addBookingItem }) => {
  const [dropdownSplitOpen, setDropdownSplitOpen] = useState(false);

  const toggleSplit = () => setDropdownSplitOpen(!dropdownSplitOpen);

  const handleMolainnKeylessAccessStatus = (status) => {
    const booking = allBookingItems[match.params.id];
    const bookingId = booking.id;
    const toPatch = { molainn_keyless_access_status: status, id: bookingId };
    addBookingItem(toPatch);
  };

  const getMolainnStatusesDropdownItems = () => {
    const { molainnKeylessAccessStatusEnum } = defaultValues;
    const { molainn_keyless_access_status } = booking;

    const molainnStatuses = Object.values(molainnKeylessAccessStatusEnum).filter(
      molainnStatus => (molainnStatus !== molainnKeylessAccessStatusEnum[molainn_keyless_access_status]
        && molainnStatus !== "booking.molainn_keyless_access_status_pending")
    );

    const molainnStatusIntlKeys = Object.keys(molainnKeylessAccessStatusEnum).filter(
      molainnStatus => molainnStatus !== molainn_keyless_access_status && molainnStatus !== "pending"
    );

    return molainnStatuses.map((molainnStatus, index) => (
      <DropdownItem
        onClick={() => handleMolainnKeylessAccessStatus(molainnStatusIntlKeys[index])} key={`${molainnStatus}`}
      >
        <IntlMessages id={`${molainnStatus}`} />
      </DropdownItem>
    ));
  }

  const paddingBottom = () => {
    if (!dropdownSplitOpen) return {};

    if (booking.molainn_keyless_access_status) {
      if (booking.molainn_keyless_access_status !== "pending") return { paddingBottom: "6.5rem" };
      else return { paddingBottom: "9.2rem" };
    }
  }

  const getMolainnKeylessAccessStatusColor = () => {
    const { molainn_keyless_access_status } = booking;
    switch (molainn_keyless_access_status) {
      case "verified":
        return "success";
      case "pending":
        return "warning";

      default:
        return "danger";
    }
  }

  // Burayı satırı hiçbir şekilde silme
  if (!hotelConfig.molainn_keyless_access) return (<></>)

  return (
    <Card className="text-center" style={{ overflow: "hidden" }}>
      <CardBody>
        <h3 className="list-item-heading mb-3">Molainn Keyless Access Status</h3>

        <div className="text-center">
          {(booking.status !== "hotel_guest") &&
            <div className="mb-3 text-center" style={{ color: "red" }}>
              <IntlMessages id="booking.molainnKeylessAccessWarningMessage" />
            </div>
          }

          <Dropdown isOpen={dropdownSplitOpen} toggle={toggleSplit}
            className="text-center w-100"
            style={paddingBottom()}
          >
            <DropdownToggle caret
              disabled={(booking.status !== "hotel_guest") ? true : false}
              color={getMolainnKeylessAccessStatusColor()}
            >
              <IntlMessages id={`${defaultValues.molainnKeylessAccessStatusEnum[booking.molainn_keyless_access_status ?? "pending"]}`} />
            </DropdownToggle>

            <DropdownMenu>{getMolainnStatusesDropdownItems()}</DropdownMenu>
          </Dropdown>
        </div>
      </CardBody>
    </Card>
  );
};

const mapStateToProps = ({ settings, bookingApp }) => {
  const { hotelConfig } = settings;
  const { allBookingItems } = bookingApp;

  return { hotelConfig, allBookingItems };
};

const mapActionsToProps = {
  addBookingItem,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(MolainnKeylessAccessContainer)
);
